<template>
  <div class="w-100">
    <div class="d-flex p-2">
      <div v-for="(menu, index) in listMenu" :key="index">
        <el-tag v-if="showMenu(menu)"
                @click="handleSelectMenu(menu.val)"
                v-bind:style="menu.val == activeMenu ? activeMenuStyle : normalMenuStyle"
                effect="dark"
                style="height:40px "
                class="pointer text-center pt-1 px-3 mx-1 mb-1 mt-2 fw-bold font-size-14"
        >
          {{ menu.label }}
        </el-tag>
      </div>
    </div>
    <div class="divider-custom w-100" />
    <div style="max-width: 99%">
      <OverviewStatistical v-if="activeMenu==0"></OverviewStatistical>
      <ConversationStatistical v-if="activeMenu==1"></ConversationStatistical>
      <EmployeeStatistical v-if="activeMenu==2"></EmployeeStatistical>
      <TagStatistical v-if="activeMenu==3" />
<!--      <ContactAiInsight v-if="activeMenu==5" />-->
      <ExportData v-if="activeMenu==4" />
    </div>
  </div>
</template>

<script>
import OverviewStatistical from "../components/statistical/OverviewStatistical";
import ConversationStatistical from "../components/statistical/ConversationStatistical";
import EmployeeStatistical from "../components/statistical/EmployeeStatistical";
import TagStatistical from "../components/statistical/TagStatistical";
import ExportData from "@/components/statistical/ExportData";
// import ContactAiInsight from "@/components/statistical/ContactAiInsight";

export default {
  name: "Dashboard",
  components: {
    // ContactAiInsight,
    ExportData,
    TagStatistical,
    EmployeeStatistical,
    ConversationStatistical,
    OverviewStatistical
  },
  computed: {
    activeMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#0A58C0",
        "background-color": this.setTransparencyHex("#0A58C0", 0.08),
        margin: "1px 4px 3px 1px"
      };
    },
    normalMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#696B72",
        "background-color": "transparent",
        margin: "1px 4px 3px 1px"
      };
    }
  },
  data() {
    return {
      listMenu: [
        { label: "Tổng quan", val: 0 },
        { label: "Tin nhắn", val: 1 },
        { label: "Nhân viên", val: 2 },
        { label: "Tag", val: 3 },
        { label: "Xuất dữ liệu", val: 4 },
        // { label: "AI Insight", val: 5 }
      ],
      activeMenu: 0
    };
  },
  methods: {
    handleSelectMenu(key) {
      this.activeMenu = key;
    },
    showMenu(menu) {
      if (menu.val == 4) {
        return this.app.user.exportData;
      }
      if (menu.val == 5) {
        return this.app.user.aiInsight;
      }
      return true;
    }
  }
};
</script>

<style scoped>

</style>
